import { render, staticRenderFns } from "./Receipt-Ticket.vue?vue&type=template&id=b64f52ca"
import script from "./Receipt-Ticket.vue?vue&type=script&lang=js"
export * from "./Receipt-Ticket.vue?vue&type=script&lang=js"
import style0 from "./Receipt-Ticket.vue?vue&type=style&index=0&id=b64f52ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports